var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"page-not-visible","ok-only":""},on:{"ok":_vm.returnToOverview}},[_c('p',[_vm._v(" "+_vm._s(_vm.pageName)+" cannot be accessed because the Project Approval Status is \""+_vm._s(_vm.project.approvalStatus)+"\". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }